/* eslint "@tanstack/query/exhaustive-deps": "off" */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';

import { useReactNativeProps } from '@eika-infrastruktur/mobilbank-lib';

import { confirmPendingCard, getApplePayPendingCards } from '@/react-query/services/card';

import hashFromString from '@utils/hashFromString';

export const PENDING_CARD_TOKEN_QUERY_KEY = 'apple-pay-pending';

export const usePendingCards = (enabled = false) => {
    const queryClient = useQueryClient();

    const nativeProps = useReactNativeProps();

    const pendingCardsNative = [
        ...(nativeProps.appleWallet?.pendingCardTokens ?? []).map(
            (pendingCard) => pendingCard.primaryAccountIdentifier.value,
        ),
    ];

    const pendingCardsKey = useMemo(
        () =>
            hashFromString(
                nativeProps?.appleWallet?.pendingCardTokens
                    .map((pass) => pass.tokenUniqueReference.value + pass.primaryAccountIdentifier.value)
                    .join() ?? '',
            ),
        [nativeProps.appleWallet?.pendingCardTokens],
    );

    const queryKey = [PENDING_CARD_TOKEN_QUERY_KEY, pendingCardsKey];

    const query = useQuery({
        queryKey,
        queryFn: () => getApplePayPendingCards(pendingCardsNative),
        enabled: (nativeProps.appleWallet?.pendingCardTokens ?? []).length > 0 && enabled,
    });

    return {
        // eslint-disable-next-line @tanstack/query/no-rest-destructuring
        ...query,
        invalidateQuery: () => queryClient.invalidateQueries({ queryKey: [PENDING_CARD_TOKEN_QUERY_KEY] }),
    };
};

export const useActivatePendingCard = () => {
    return useMutation({
        mutationKey: ['activate-pending-card'],
        mutationFn: confirmPendingCard,
    });
};
